export default "__VITE_ASSET__CcfDtpZn__"